import { render, staticRenderFns } from "./PaymentMadeList.vue?vue&type=template&id=f2b780f8&"
import script from "./PaymentMadeList.vue?vue&type=script&lang=js&"
export * from "./PaymentMadeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports